import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  // State
  const isDark = ref(false)

  // Actions
  const initializeTheme = () => {
    // Check for saved theme preference or default to light theme
    const savedTheme = localStorage.getItem('theme')
    
    if (savedTheme) {
      isDark.value = savedTheme === 'dark'
    } else {
      // Default to light theme instead of system preference
      isDark.value = false
    }
    
    applyTheme()
  }

  const toggleTheme = () => {
    isDark.value = !isDark.value
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
    applyTheme()
  }

  const setTheme = (theme) => {
    isDark.value = theme === 'dark'
    localStorage.setItem('theme', theme)
    applyTheme()
  }

  const applyTheme = () => {
    if (isDark.value) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  const resetToDefault = () => {
    localStorage.removeItem('theme')
    // Reset to default light theme
    isDark.value = false
    applyTheme()
  }

  // Watch for theme changes and apply them
  watch(isDark, () => {
    applyTheme()
  })

  return {
    // State
    isDark,
    
    // Actions
    initializeTheme,
    toggleTheme,
    setTheme,
    resetToDefault
  }
}) 